import { useReduxState } from 'hooks';
import { PageInnerContent, PageSidebar } from 'components/page';
import { ProfilePage } from '.';

const ProfileSettingsPage = ({ activeLink = '', children }) => {
  const {
    messages,
    pageState: { user },
    serverConfig: {
      authAllowPasswordSetForSsoUser,
      disableAccountDeleteRequests,
      platformCompetenciesOnly
    }
  } = useReduxState();

  const enablePasswordPage =
    ['local', 'local-totp'].includes(user?.authenticatorType) ||
    authAllowPasswordSetForSsoUser;

  const sidebarLinks = user
    ? [
        ...(enablePasswordPage
          ? [
              {
                href: `/profile/auth`,
                icon: 'lock' as const,
                title: messages.profilePasswordAndLogin
              }
            ]
          : []),
        ...(platformCompetenciesOnly
          ? []
          : [
              {
                href: `/profile/summary-email`,
                icon: 'envelope' as const,
                title: messages.settingsSummaryEmail
              }
            ]),
        {
          href: `/profile/data`,
          icon: 'database' as const,
          title: messages.profileUserData
        },
        ...(disableAccountDeleteRequests
          ? []
          : [
              {
                href: `/profile/delete`,
                icon: 'trash-alt' as const,
                title: messages.profileAccountDeletion
              }
            ])
      ]
    : null;

  return (
    <ProfilePage
      activeLink={
        enablePasswordPage
          ? '/auth'
          : !platformCompetenciesOnly
          ? '/summary-email'
          : '/data'
      }
      withSidebar={true}
    >
      <PageSidebar active={`/profile${activeLink}`} links={sidebarLinks} />
      <PageInnerContent>{children}</PageInnerContent>
    </ProfilePage>
  );
};

export default ProfileSettingsPage;
